import { Component } from '@angular/core';
import { DialogLogoutComponent } from './auth/dialog/dialog-logout/dialog-logout.component';
import { NavigationEnd, Router } from '@angular/router';
import { SharedServiceService } from './auth/shared-service.service';
import { MatDialog } from '@angular/material/dialog';
import { NbAuthService } from '@nebular/auth';
import { TimeoutService } from './auth/time-out.service';
import { Location } from '@angular/common';
import { SeguridadService, infoAuditoria } from './services/seguridad.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'NewFront';

  name: string = 'Session Counter Example';
  sessionTimer: any;
  defaultTimeoutSeconds: number = 0;
  defaultShowPopupSeconds: number | undefined;
  timeoutSeconds: number = 0;
  dateExp: number = 0;
  dateTimeExp?: Date;
  timerMinute?: Date;
  dateTimeDialog?: Date;
  sessionMessage: string | undefined;
  showTimeoutPopup: boolean = false;
  boStarTimer: boolean = false;
  timeDialogShow: number = 5;
  timeDifference: number = 0;

  auditoria?: infoAuditoria;

  constructor(private router: Router, private _sharedService: SharedServiceService,
    private dialog: MatDialog, private location: Location,
    private nbAuthService: NbAuthService, private timeoutService: TimeoutService,
    private seguridadService: SeguridadService) {

  }

  ngOnInit() {
    this._sharedService.changeEmitted$.subscribe(
      data => {
        this.defaultTimeoutSeconds = data.defaultTimeoutSeconds;
        this.defaultShowPopupSeconds = data.defaultShowPopupSeconds;
        this.dateExp = data.dateExp;
        this.startTimer(1000);
        // this.subscribeToRouterEvents();
        // if (!this.timeoutSeconds || this.timeoutSeconds !== 0) {
        //   this.resetSession();
        // }
      });
  }

  subscribeToRouterEvents() {
    this.router.events.subscribe((val) => {
      // console.log("Entro a app.component");
      this.showTimeoutPopup = false;
      if (val instanceof NavigationEnd && val.url !== '/auth/loginDav') {
        this.resetSession();
      }
    });
  }

  startTimer(interval: number) {

    this.timeoutSeconds = this.defaultTimeoutSeconds;
    this.dateTimeExp = new Date(this.dateExp * 1000);
    // console.log("Fecha expiracion: ", this.dateTimeExp);
    this.dateTimeDialog = new Date(this.dateTimeExp);
    //---------Pruebas------------//
    // this.dateTimeDialog?.setMinutes(this.dateTimeDialog.getMinutes() - 59);
    // console.log("Fecha Dialog: ", this.dateTimeDialog);
    // //---------
    this.dateTimeDialog?.setMinutes(this.dateTimeDialog.getMinutes() - this.timeDialogShow);

    // console.log("this.dateTimeExp", this.dateTimeExp)
    // console.log("this.dateTimeDialog", this.dateTimeDialog)
    let dialogShown = false;
    if (this.boStarTimer === false) {
      this.boStarTimer = true;
      this.timeoutService.currentTimeSubject.subscribe((currentDate: Date) => {
        this.timerMinute = currentDate;

        if (this.dateTimeExp) {
          this.timeDifference = (this.dateTimeExp.getTime() - this.timerMinute.getTime()) / (1000 * 60);
          this.timeDifference = Math.abs(this.timeDifference);
        }

        if (!dialogShown && this.timeDifference < 5 && this.timeDifference > 0) {
          this.sessionMessage = `La sesión expirará en ${Math.round(this.timeDifference)} minutos(s)`;
          this.toggleShowTimeoutPopup();
          dialogShown = true;
        }
        // //console.log('tiempo de servicio modificado', this.timerMinute)
        // if (this.dateTimeDialog?.getHours() === this.timerMinute.getHours() &&
        //   this.dateTimeDialog?.getMinutes() === this.timerMinute.getMinutes() &&
        //   this.dateTimeDialog?.getSeconds() === this.timerMinute.getSeconds()) {
        //   this.sessionMessage = `La sesión expirará en ${this.dateTimeDialog?.getMinutes() !== undefined && this.dateTimeExp?.getMinutes() !== undefined
        //       ? this.dateTimeExp.getMinutes() - this.dateTimeDialog.getMinutes()
        //       : 'N/A'
        //     } minuto(s)`;

        //   this.toggleShowTimeoutPopup();

        // }

        if (this.dateTimeExp) {
          if (this.dateTimeExp?.getTime() <= this.timerMinute.getTime()) {
            this.logoutUser();
          }
        }

      });
      this.timeoutService.startTimer();
    }
  }

  resetSession() {
    window.clearInterval(this.sessionTimer);
    this.sessionTimer = this.startTimer(1000);
    this.showTimeoutPopup = false;
  }

  logoutUser() {
    window.clearInterval(this.sessionTimer);
    this.sessionMessage = 'User logged out due to inactivity!';
    this.showTimeoutPopup = false;
    const name = localStorage;
    localStorage.clear();
    setTimeout(() => {
      this.auditoria = {
        tFormulario : '~/auth/logout',
        tDescripcion: "Se cerro la sesión automaticamente por inactividad.."
      };
      this.seguridadService.setAuditoria(this.auditoria).subscribe();
      location.reload();
      this.nbAuthService.logout('email').subscribe(res => {
        res.isSuccess() && this.router.navigate(['/auth/logout'])
      })
    }, 3000)
  }

  toggleShowTimeoutPopup() {
    this.showTimeoutPopup = !this.showTimeoutPopup;
    const dialogRef = this.dialog.open(DialogLogoutComponent, {
      disableClose: true,
      width: '30%',
      data: this.sessionMessage
    });

    // setTimeout(() => {
    //   dialogRef.close();
    // }, 10000)

    dialogRef.afterClosed().subscribe(res => {
      //console.log(res);
    });
  }
}
